import React from 'react';

import ActionItemsContext from './ActionItemsContext';
import ActionItemsContextProvider from './ActionItemsContextProvider';

const withActionItemsContextProvider = (Component) => (props) => (
  <ActionItemsContextProvider>
    <Component {...props} />
  </ActionItemsContextProvider>
);

export default ActionItemsContext;
export { withActionItemsContextProvider };
